// initial state
const state = {
  searchAdminButton: null,

  checkingCart: null,

  navHeight: 0,

  routeTransition: null,

  /** Resolve function for view transition readiness. Called when target page has rendered its transition element. */
  viewTransitionReadyResolve: null,

  projects2CacheKey: 0,
}

// mutations
const mutations = {
  setSearchAdminButton (state, data) {
    state.searchAdminButton = data
  },

  setCheckingCart (state, data) {
    state.checkingCart = data
  },

  setNavHeight(state, data) {
    state.navHeight = data
  },

  setRouteTransition(state, scope = null) {
    state.routeTransition = scope || null
  },

  setViewTransitionReadyResolve(state, resolve = null) {
    state.viewTransitionReadyResolve = resolve
  },

  bustProjects2Cache(state) {
    state.projects2CacheKey++
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
